import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, isRef as _isRef, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f1021dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_3 = {
  key: 1,
  class: "empty"
}
const _hoisted_4 = {
  name: "fileImg",
  style: {"display":"inline-block"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "toolBox" }
const _hoisted_8 = { class: "toolBoxHeader" }
const _hoisted_9 = { class: "tboxItem" }
const _hoisted_10 = {
  name: "fileImg",
  style: {"display":"inline-block"}
}
const _hoisted_11 = { class: "tboxItem" }
const _hoisted_12 = { class: "tboxItem" }
const _hoisted_13 = { class: "tboxItem" }
const _hoisted_14 = { class: "tboxItem" }
const _hoisted_15 = { class: "tboxItem" }
const _hoisted_16 = { class: "tboxItem" }
const _hoisted_17 = { class: "tboxItem" }
const _hoisted_18 = { class: "tboxItem" }
const _hoisted_19 = { class: "tboxItem" }
const _hoisted_20 = {
  name: "fileImg",
  style: {"display":"inline-block"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_22 = { style: {"padding":"0px"} }
const _hoisted_23 = { class: "imginfoitem" }
const _hoisted_24 = { class: "imginfoitem" }
const _hoisted_25 = { class: "imginfoitem" }
const _hoisted_26 = { class: "imginfoitem" }
const _hoisted_27 = { class: "imginfoitem" }
const _hoisted_28 = {
  key: 3,
  class: "",
  style: {"display":"flex","justify-content":"center"}
}

import { tmui_img_resize, tmui_img_compress, cpos_img, get_img_info } from '../../public/pkg/tmui_xz.js';
	import { toBase64 } from "@/libs/util"
	import Vue3DraggableResizable from 'vue3-draggable-resizable'
	import { appStore } from '@/store/appStore';
	import { computed, onMounted, reactive, ref, shallowRef, Ref, nextTick } from 'vue';
	import JSZip from "jszip"
	import { useObjectUrl, useDraggable } from '@vueuse/core'
	// { data, post, terminate, worker }
	
export default /*#__PURE__*/_defineComponent({
  __name: 'PageImageResize',
  setup(__props) {

_useCssVars(_ctx => ({
  "7f456ce5": (_unref(imganiDur))
}))

	const imageWorker = new Worker('/pkg/tmui_xz_worker.js');
	const el = ref<HTMLElement | null>(null)
	const { style } = useDraggable(el, {
		initialValue: { y: 90, x: 20 },
		preventDefault: false,
	})
	const fileObj = shallowRef()
	const imageurl = useObjectUrl(fileObj)
	const store = appStore()
	var realData = ""
	var imgDragAndResize = ref(false)
	const imganiDur = computed(() => imgDragAndResize.value ? 0 : '0.6s')

	const imgopts = reactive({
		x: window.innerWidth / 2,
		y: window.innerHeight / 2,
		w: 50,
		h: 50,
		size: 0,
		realWidth: 0,
		realHeight: 0,
		localWidth: 0,
		localHeight: 0,
		lockScale: true,
		zhiliang: 100,
		formart: "jpeg",
		mimeType: "",
		fileName: "",
		/** 没有后缀的文件名。 */
		fileNameNosuffix: ""
	})
	const imgSizeCovert = computed(() => {
		if (!imgopts.size) return "0b";
		if (imgopts.size < 1024 * 1000) return (imgopts.size / 1024).toFixed(2) + "KB";
		if (imgopts.size < 1024 * 1024 * 1024) return (imgopts.size / 1024 / 1024).toFixed(2) + "MB";
		return (imgopts.size / 1024 / 1024 / 1024).toFixed(2) + "GB";
	})
	const whscale = computed(() => {
		if (!imgopts.realWidth) return "";
		return (imgopts.w / imgopts.realWidth * 100).toFixed(0) + "%"
	})
	const imgFormatList = ["jpg", "jpeg", "png", "gif", "bmp", "ico", "tiff"]

	onMounted(() => {

		window.onresize = () => {
			resetSizePos()
		}


	})
	function imgresizeChange(e) {
		console.log(e)
	}
	function watchFileChange(e) {
		if (!e.srcElement.files || !e.srcElement?.files?.length) return;
		const file = e.srcElement.files[0];
		store.loading = true;
		imgopts.mimeType = file.type;
		imgopts.fileName = file.name;
		imgopts.fileNameNosuffix = file.name.substring(0, file.name.lastIndexOf("."));
		imgopts.size = file.size;
		fileObj.value = file

		toBase64(file).then((result) => {
			let d = <string>result;
			realData = d;
			var imgObj = new Image();
			imgObj.src = d;
			imgObj.onload = () => {
				const { width, height } = imgObj;
				imgopts.realHeight = height;
				imgopts.realWidth = width;

				imgopts.localHeight = height;
				imgopts.localWidth = width;
				var imgFormat = file.name.substring(file.name.lastIndexOf(".") + 1);
				imgopts.formart = imgFormat == "webp" ? "jpg" : imgFormat;

				resetSizePos();
				imgObj.remove()
			}
			// getImgopts(d);
			store.loading = false;
		});
	}
	// 暂时弃用.调用rust获取图片信息.
	function getImgopts(d : string) {
		const imginfo = get_img_info(d, imgopts.mimeType).split(",")
		const [imgFormat, imgWidth, imgHeight, imgSize] = imginfo;
		// imgopts.size = Number(imgSize);
		imgopts.realWidth = Number(imgWidth);
		imgopts.realHeight = Number(imgHeight);
		imgopts.formart = imgFormat == "webp" ? "jpg" : imgFormat;
		resetSizePos();
	}
	function resetSizePos() {
		const cw = Math.floor(window.innerWidth * 0.9);
		const ch = Math.floor((window.innerHeight - 70) * 0.9);
		const minh = Math.min(ch, cw);
		const sw = 0;
		const sh = 0;
		if (imgopts.realWidth >= cw && imgopts.realHeight >= ch) {

			//如果考虑竖向屏时，要考虑cw,ch的高度。
			if (cw >= ch) {
				imgopts.h = ch;
				imgopts.w = imgopts.realWidth * ch / imgopts.realHeight;
			} else {
				imgopts.h = cw;
				imgopts.w = imgopts.realWidth * cw / imgopts.realHeight;
			}
		} else if (imgopts.realWidth > cw && imgopts.realHeight < ch) {
			imgopts.w = cw;
			imgopts.h = imgopts.realHeight * cw / imgopts.realWidth;
		} else if (imgopts.realWidth < cw && imgopts.realHeight > ch) {
			imgopts.h = ch;
			imgopts.w = imgopts.realWidth * ch / imgopts.realHeight;
		} else {
			imgopts.w = imgopts.realWidth;
			imgopts.h = imgopts.realHeight;
		}
		imgopts.w = Math.floor(imgopts.w)
		imgopts.h = Math.floor(imgopts.h)
		imgopts.x = (window.innerWidth - imgopts.w) / 2;
		imgopts.y = (window.innerHeight - imgopts.h) / 2;
	}
	function resetSizePosScale(type : "+" | "-") {
		const scale = type == "+" ? 1.15 : 0.85;
		imgopts.w = Math.floor(imgopts.w * scale)
		imgopts.h = Math.floor(imgopts.h * scale)
		imgopts.x = (window.innerWidth - imgopts.w) / 2;
		imgopts.y = (window.innerHeight - imgopts.h) / 2;
	}
	function heightChangeend(e, type : string) {
		var imgw = 0;
		var imgh = 0;
		if (type == 'w') {
			imgw = Number(e.srcElement.value);

			if (imgopts.lockScale) {
				imgh = imgw * imgopts.realHeight / imgopts.realWidth
			} else {
				imgh = imgopts.realHeight
			}

		} else {
			imgh = Number(e.srcElement.value);
			if (imgopts.lockScale) {
				imgw = imgopts.realWidth * imgh / imgopts.realHeight
			} else {
				imgw = imgopts.realWidth
			}
		}
		imgopts.realWidth = Math.floor(imgw)
		imgopts.realHeight = Math.floor(imgh)
		imgopts.w = imgw
		imgopts.h = imgh
		imgopts.x = (window.innerWidth - imgw) / 2;
		imgopts.y = (window.innerHeight - imgh) / 2;
		resetSizePos()

	}
	function lockScallBlv(e) {
		imgopts.lockScale = e.srcElement.ariaChecked == 'true' ? true : false;
	}
	function selectedImgFormart(fkey : string) {
		imgopts.formart = fkey;
	}
	function zhiliangSliedreChange(e) {
		imgopts.zhiliang = parseInt(e.srcElement.value);
	}
	function wheelScale(e : WheelEvent) {
		e.preventDefault();

		const mouseX = e.layerX;
		const mouseY = e.layerY;

		const scale = e.deltaY > 0 ? 0.85 : 1.15;

		const width = imgopts.w * scale;
		const height = imgopts.h * scale;
		if (width < 20 || height < 20) return;
		const newMouseX = mouseX * scale;
		const newMouseY = mouseY * scale;
		const deltaX = (newMouseX - mouseX);
		const deltaY = (newMouseY - mouseY);
		const x = imgopts.x - deltaX;
		const y = imgopts.y - deltaY;

		imgopts.x = x;
		imgopts.y = y;
		imgopts.w = width;
		imgopts.h = height;
	}
	function chuli() {
		store.loading = true;
		imageWorker.postMessage({
			name: "cpos_img",
			data: [realData, imgopts.mimeType, imgopts.realWidth, imgopts.realHeight, imgopts.zhiliang, 0, imgopts.formart]
		})

		imageWorker.onmessage = async (e) => {
			if (e.data?.name == "cpos_img") {
				const psHandle = await window.showSaveFilePicker({
					dataType: "ArrayBuffer",
					types: [{
						description: '保存图像',
						accept: {
							'images/*': ['.jpg', '.jpeg', '.png', '.gif', '.tiff', '.bmp', '.ico'],
						},
					}],
					suggestedName:imgopts.fileNameNosuffix+"-(副本)."+imgopts.formart,
					excludeAcceptAllOption: true,
				}).catch(e=>{
					store.loading = false;
					return;
				})
				if(!psHandle) return;
				// Create a FileSystemWritableFileStream to write to.
				const writable = await psHandle.createWritable()
				if(!writable) return;
				await writable.write(e.data?.data);
				await writable.close();
				store.loading = false;
			}
		}
		
	}

	function gzipDownload(data : string) {

		// 创建一个新的jsZip实例
		var zip = new JSZip();
		// var jpgFormat = imgopts.fileName.substring(imgopts.fileName.lastIndexOf("."));
		// 添加文件到zip中
		// zip.file("hello.txt", "Hello World\n");
		// 创建一个文件夹
		// var imgFolder = zip.folder("images");
		// 添加图片到文件夹中
		zip.file(imgopts.fileNameNosuffix + "." + imgopts.formart, data, { binary: true });
		// 生成zip文件
		zip.generateAsync({ type: "blob" })
			.then(function (content) {
				// 创建一个下载链接并模拟点击下载
				var link = document.createElement('a');
				link.download = imgopts.fileNameNosuffix + ".zip";
				link.href = URL.createObjectURL(content);
				link.click();
				link.remove()
				zip = undefined;
			});
	}

return (_ctx: any,_cache: any) => {
  const _component_x_throbber = _resolveComponent("x-throbber")!
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_label = _resolveComponent("x-label")!
  const _component_x_numberinput = _resolveComponent("x-numberinput")!
  const _component_x_switch = _resolveComponent("x-switch")!
  const _component_x_slider = _resolveComponent("x-slider")!
  const _component_x_input = _resolveComponent("x-input")!
  const _component_x_menuitem = _resolveComponent("x-menuitem")!
  const _component_x_menu = _resolveComponent("x-menu")!
  const _component_x_select = _resolveComponent("x-select")!
  const _component_x_accordion = _resolveComponent("x-accordion")!
  const _component_x_card = _resolveComponent("x-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_x_throbber, { size: "large" })
        ]))
      : _createCommentVNode("", true),
    (!_unref(imageurl) && !_unref(store).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createElementVNode("input", {
              onChange: watchFileChange,
              style: {"display":"none"},
              ref: "file",
              id: "fileImg",
              name: "fileImg",
              type: "file",
              accept: "image/*"
            }, null, 544),
            _createVNode(_component_x_button, {
              toggled: "",
              style: {"width":"100px","height":"100px","border-radius":"50%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_icon, {
                  href: "#ri-image-add-fill",
                  style: {"width":"40px","height":"40px"}
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_unref(imageurl))
        ? (_openBlock(), _createBlock(_unref(Vue3DraggableResizable), {
            key: 0,
            onWheel: wheelScale,
            class: "imagetransi imagebox",
            onDragStart: _cache[0] || (_cache[0] = ($event: any) => (_isRef(imgDragAndResize) //@ts-ignore
 ? imgDragAndResize.value = true : imgDragAndResize = true)),
            onResizeStart: _cache[1] || (_cache[1] = ($event: any) => (_isRef(imgDragAndResize) //@ts-ignore
 ? imgDragAndResize.value = true : imgDragAndResize = true)),
            onDragging: _cache[2] || (_cache[2] = ($event: any) => (_isRef(imgDragAndResize) //@ts-ignore
 ? imgDragAndResize.value = true : imgDragAndResize = true)),
            onResizing: _cache[3] || (_cache[3] = ($event: any) => (_isRef(imgDragAndResize) //@ts-ignore
 ? imgDragAndResize.value = true : imgDragAndResize = true)),
            onDragEnd: _cache[4] || (_cache[4] = ($event: any) => (_isRef(imgDragAndResize) //@ts-ignore
 ? imgDragAndResize.value = false : imgDragAndResize = false)),
            onResizeEnd: _cache[5] || (_cache[5] = ($event: any) => (_isRef(imgDragAndResize) //@ts-ignore
 ? imgDragAndResize.value = false : imgDragAndResize = false)),
            handles: ['tl', 'tr', 'bl', 'br'],
            onChange: imgresizeChange,
            x: imgopts.x,
            "onUpdate:x": _cache[6] || (_cache[6] = ($event: any) => ((imgopts.x) = $event)),
            y: imgopts.y,
            "onUpdate:y": _cache[7] || (_cache[7] = ($event: any) => ((imgopts.y) = $event)),
            w: imgopts.w,
            "onUpdate:w": _cache[8] || (_cache[8] = ($event: any) => ((imgopts.w) = $event)),
            h: imgopts.h,
            "onUpdate:h": _cache[9] || (_cache[9] = ($event: any) => ((imgopts.h) = $event)),
            initW: imgopts.w,
            initH: imgopts.h,
            draggable: true,
            resizable: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                style: _normalizeStyle({ width: (imgopts.w-2) + 'px', height: (imgopts.h-2) + 'px' }),
                src: _unref(imageurl),
                class: "imagetransi"
              }, null, 12, _hoisted_5)
            ]),
            _: 1
          }, 8, ["x", "y", "w", "h", "initW", "initH"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(imageurl))
      ? (_openBlock(), _createBlock(_component_x_card, {
          key: 2,
          class: "tool",
          style: _normalizeStyle(_unref(style))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_x_label, {
              style: {"padding":"15px","font-size":"16px","font-weight":"bold"},
              ref_key: "el",
              ref: el
            }, {
              default: _withCtx(() => [
                _createTextVNode("操作菜单(按住这里可拖动)")
              ]),
              _: 1
            }, 512),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("打开新图片")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("label", _hoisted_10, [
                    _createElementVNode("input", {
                      onChange: watchFileChange,
                      style: {"display":"none"},
                      id: "fileImg",
                      name: "fileImg",
                      type: "file",
                      accept: "image/*"
                    }, null, 32),
                    _createVNode(_component_x_button, {
                      color: "green",
                      style: {"min-width":"138px"},
                      toggled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_icon, { href: "#ri-folder-open-line" }),
                        _createVNode(_component_x_label, { style: {} }, {
                          default: _withCtx(() => [
                            _createTextVNode("打开")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("宽度")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_x_numberinput, {
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (heightChangeend($event, 'w'))),
                    value: imgopts.realWidth,
                    min: 10,
                    style: {"min-width":"138px","margin":"0px"}
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("高度")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_x_numberinput, {
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (heightChangeend($event, 'h'))),
                    value: imgopts.realHeight,
                    min: 10,
                    style: {"min-width":"138px","margin":"0px"}
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_x_label, { class: "title" }),
                  _createVNode(_component_x_button, {
                    skin: "flat",
                    style: {},
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {imgopts.realHeight=imgopts.localHeight;imgopts.realWidth = imgopts.localWidth;resetSizePos();})
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_x_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("重置宽度")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("锁定比例")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_x_switch, {
                    ariaChecked: imgopts.lockScale,
                    toggled: "",
                    onToggle: lockScallBlv
                  }, null, 8, ["ariaChecked"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("图片质量")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_x_slider, {
                    style: {"width":"140px"},
                    onChange: zhiliangSliedreChange,
                    min: 30,
                    max: 100,
                    value: imgopts.zhiliang
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_x_label, { value: "30" }, {
                        default: _withCtx(() => [
                          _createTextVNode("差")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { value: "64" }, {
                        default: _withCtx(() => [
                          _createTextVNode("中")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { value: "100" }, {
                        default: _withCtx(() => [
                          _createTextVNode("好")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_x_label, { class: "title" }),
                  _createVNode(_component_x_numberinput, {
                    onChange: zhiliangSliedreChange,
                    style: {"width":"138px","margin":"0px"},
                    value: imgopts.zhiliang,
                    min: 30,
                    max: 100,
                    suffix: "%"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("文件名")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_x_input, {
                    style: {"width":"138px"},
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (imgopts.fileNameNosuffix = $event.target.value)),
                    value: imgopts.fileNameNosuffix
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_x_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("请输入")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_x_label, { class: "title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存格式")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_x_select, {
                    style: {"width":"138px"},
                    value: imgopts.formart
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_x_menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imgFormatList, (item, index) => {
                            return _createVNode(_component_x_menuitem, {
                              key: index,
                              onClick: ($event: any) => (selectedImgFormart(item)),
                              value: item
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_x_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "value"])
                          }), 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _createVNode(_component_x_button, {
                      disabled: _unref(store).loading,
                      style: {"width":"227px"},
                      onClick: chuli,
                      toggled: ""
                    }, {
                      default: _withCtx(() => [
                        (_unref(store).loading)
                          ? (_openBlock(), _createBlock(_component_x_throbber, {
                              key: 0,
                              small: "small"
                            }))
                          : (_openBlock(), _createBlock(_component_x_icon, {
                              key: 1,
                              href: "#ri-install-line"
                            })),
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("保存")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ])
            ]),
            _hoisted_21,
            _createVNode(_component_x_accordion, { style: {"padding":"0 15px"} }, {
              default: _withCtx(() => [
                _createElementVNode("header", null, [
                  _createVNode(_component_x_label, { style: {"padding":"0px","font-size":"14px"} }, {
                    default: _withCtx(() => [
                      _createTextVNode("图像信息")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("main", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_x_label, { class: "imginfoitemTextLeft" }, {
                        default: _withCtx(() => [
                          _createTextVNode("名称")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { class: "imginfoitemTextRight" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(imgopts.fileName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_x_label, { class: "imginfoitemTextLeft" }, {
                        default: _withCtx(() => [
                          _createTextVNode("宽度")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { class: "imginfoitemTextRight" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(imgopts.realWidth) + " x " + _toDisplayString(imgopts.realHeight), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_x_label, { class: "imginfoitemTextLeft" }, {
                        default: _withCtx(() => [
                          _createTextVNode("尺寸")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { class: "imginfoitemTextRight" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(imgSizeCovert)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_x_label, { class: "imginfoitemTextLeft" }, {
                        default: _withCtx(() => [
                          _createTextVNode("格式")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { class: "imginfoitemTextRight" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(imgopts.formart), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_x_label, { class: "imginfoitemTextLeft" }, {
                        default: _withCtx(() => [
                          _createTextVNode("类型")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_x_label, { class: "imginfoitemTextRight" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(imgopts.mimeType), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    (_unref(imageurl))
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_component_x_card, { class: "toolBoxBootom" }, {
            default: _withCtx(() => [
              _createVNode(_component_x_button, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (resetSizePosScale('-'))),
                class: "iconItem",
                skin: "flat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_x_icon, { href: "#ri-subtract-line" })
                ]),
                _: 1
              }),
              _createVNode(_component_x_label, { onClick: resetSizePos }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(whscale)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_x_button, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (resetSizePosScale('+'))),
                class: "iconItem",
                skin: "flat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_x_icon, { href: "#ri-add-line" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})